(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/mobile-dialogs.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/mobile-dialogs.js');
"use strict";


const showSuccessDialog = phone => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'mobile',
    branding: svs.ui.dialog.branding.TUR,
    title: "Bekr\xE4fta ditt nya nummer med koden vi har skickat dig",
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: "Nytt nummer: ".concat(phone)
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog); 
};
const showErrorDialog = message => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: 'Det gick inte att spara telefonnumret.',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: message
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog); 
};
const showDeleteErrorDialog = () => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: 'Det gick inte att ta bort telefonnumret.',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Vänligen försök igen senare. Om problemet kvarstår kan du höra av dig till kundservice.'
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog); 
};
const confirmDelete = async () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    title: 'Vill du ta bort ditt mobilnummer?',
    icon: 'mobile',
    branding: svs.ui.dialog.branding.TUR,
    actions: [{
      title: 'Avbryt',
      callback: () => {
        resolve(false);
        dialog.close();
      }
    }, {
      title: 'Ta bort',
      callback: () => {
        resolve(true);
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const onDeleteCellphoneSuccess = () => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    title: 'Mobilnummer borttaget.',
    actions: [{
      title: 'Okej'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showMobileUseInformation = () => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'mobile',
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.CONFIRM,
    title: 'Vi använder ditt mobilnummer för att',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: "\n          <ul>\n            <li>Kunna ringa dig vid st\xF6rre vinst</li>\n            <li>F\xF6ra \xF6ver pengar genom en betaltj\xE4nst</li>\n            <li>Kunna skicka information och erbjudanden via sms (direktmarknadsf\xF6ring)</li>\n            <li>Kontakta dig vid behov, t.ex. av legala sk\xE4l</li>\n          </ul>\n          Du kan hantera ditt mobilnummer och val f\xF6r direktmarknadsf\xF6ring under Min profil.",
      align: svs.ui.dialog.message.align.LEFT
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileDialogs = {
  showSuccessDialog,
  showErrorDialog,
  showMobileUseInformation,
  confirmDelete,
  onDeleteCellphoneSuccess,
  showDeleteErrorDialog
};

 })(window);